import type { PropsWithChildren } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { CampaignHeader } from "./components/campaign-header";
import type { Locations } from "./components/metadata-info";
import { MetadataInfo } from "./components/metadata-info";
import { WidgetGrid } from "./components/widget-grid";

interface IMetricsWidgetCollectionProps extends PropsWithChildren {
    id: string;
    domain: string;
    campaignName: string;
    periodLabel: string;
    locations: Locations;
    onClick?: () => void;
    sharedBy?: string;
    isOwner?: boolean;
    type?: "Demo" | "Normal";
    href: string;
    target?: string;
    onShare: (link: string) => void;
    onSettings?: (campaignId: string) => void;
}

const StyledLinkContainer = styled.a`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    gap: 16px;
    padding: 16px;
    background: ${colorsPalettes.sky["100"]};
    border-radius: 6px;
    width: 100%;
    text-decoration: none;
    color: inherit;
    transition: box-shadow 0.15s ease-in-out;
    cursor: pointer;

    &:hover {
        box-shadow: 0 18px 34px 0 rgba(14, 30, 62, 0.12);
        text-decoration: none;
        color: inherit;
    }

    &:visited {
        color: inherit;
    }
`;

export const MetricsWidgetCollection = ({
    id,
    children,
    domain,
    campaignName,
    periodLabel,
    locations,
    onClick,
    sharedBy,
    isOwner,
    href,
    target,
    onShare,
    onSettings,
    type = "Normal",
}: IMetricsWidgetCollectionProps) => {
    return (
        <StyledLinkContainer
            href={href}
            target={target}
            onClick={onClick}
        >
            <Flex justifyContent="space-between">
                <CampaignHeader
                    domain={domain}
                    campaignName={campaignName}
                    sharedBy={sharedBy}
                    isOwner={isOwner}
                    type={type}
                />
                <MetadataInfo
                    period={periodLabel}
                    locations={locations}
                    onShareClick={() => onShare(href)}
                    onSettingsClick={() => onSettings?.(id)}
                />
            </Flex>

            <WidgetGrid>{children}</WidgetGrid>
        </StyledLinkContainer>
    );
};
